import { createErrorMessageTypeGuard } from '../createErrorMessageTypeGuard';
import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { CourseAssignmentCompletionDocument } from './@types';

export function completeTeamCourseAssignments(
   assignee_teamid: number,
   documents: CourseAssignmentCompletionDocument[],
   common: CommonRequestOptions = {}
): Promise<void> {
   return makeRequest('patch', `/course_assignments/Team/completeAll/${assignee_teamid}`, {
      ...common,
      body: {
         documents,
      },
   });
}

type CompleteTeamCourseAssignmentsErrorCode =
   | 'course_assignments.complete_team.team_not_found'
   | 'course_assignments.complete_team.insufficient_privileges';

completeTeamCourseAssignments.errorMessages =
   createErrorMessageTypeGuard<CompleteTeamCourseAssignmentsErrorCode>();
